import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
// import {
//   ClerkProvider,
//   SignedIn,
//   SignedOut,
//   UserButton,
//   useUser,
//   RedirectToSignIn,
// } from "@clerk/clerk-react";

// Get the Publishable Key from the environment
// const clerk_pub_key = "pk_test_d2FudGVkLW1hY2tlcmVsLTc1LmNsZXJrLmFjY291bnRzLmRldiQ"

// En tu archivo principal de JavaScript (ej. index.js o App.js)
localStorage.removeItem('cachedBars');


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
    {/* <ClerkProvider appearance={{
        baseTheme: "dark"
      }} publishableKey={clerk_pub_key} >
      <SignedIn> */}
        <App />
      {/* </SignedIn>
      <SignedOut>
        <RedirectToSignIn />
      </SignedOut>
    </ClerkProvider> */}
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
